import Swal from 'sweetalert2/dist/sweetalert2.js';
import {Injectable} from '@angular/core';
import {HttpApiService} from '../../shared/services/http-api.service';
import {HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {ApiResponseModel} from '../../shared/entities/api-response.model';
import {QuestionnaireModel} from '../models/questionnaire.model';

@Injectable({
    providedIn: 'root'
})

export class QuestionService {

    constructor(
        public httpApiService: HttpApiService,
        private router: Router,
    ) {

    }

    getTable(): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('questionnaire/index');
    }

    getQuestionnaire(uid: string): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('questionnaire/findOne', {uid: uid});
    }

    saveQuestionnaire(questionnaire: QuestionnaireModel): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('questionnaire/store', questionnaire);
    }

    updateQuestionnaire(questionnaire: QuestionnaireModel): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('questionnaire/update', questionnaire);
    }

    getUserQuestionnaireResult(uid: string): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('questionnaire/get-user-result', {uid: uid});
    }

    saveUserQuestionnaireResult(questionnaire: QuestionnaireModel): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('questionnaire/store-user-result', questionnaire);
    }


}


